import { _Filter_Types } from "./";
import { Constant } from "../../Common";
const {  FilterAdditionalAction } = Constant;

const FilterActions = {
	..._Filter_Types,
	...FilterAdditionalAction
};

export default FilterActions;
